import React from "react";
import "./Skills.css";
import img from "../../../../assets/images/Skills/Group 5.png";
import { useTranslation } from "react-i18next";
function Skills() {
  const { t } = useTranslation();
  return (
    <div className="skills">
      <div className="skills-text-main">
        <div className="skills-text-head">
          <h2> {t("Master In-Demand Skills.")}</h2>
        </div>
        <div className="skills-text-para">
          <p>
            {t("Course equip")}
            {t("Language like")}
          </p>
        </div>
      </div>
      <div className="skills-img">
        <img src={img} alt="skill"/>
      </div>
    </div>
  );
}

export default Skills;
